import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { TerminalRegistrationRepository } from '@app/domain/ports/tpv/terminal-registration.repository';
import { CreateTerminalDto } from '@app/data/dtos/tpv/register-terminal.dto';

/**
 * Mock del alta de terminales para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia y siempre confirma el alta (201 → void).
 */
@Injectable()
export class TerminalRegistrationMockDataSource extends TerminalRegistrationRepository {
  override registerTerminal(
    _dto: CreateTerminalDto,
    _idempotencyKey?: string,
  ): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
}
